module.exports = __webpack_public_path__ + "static/media/bottle-pic.3f4bf541.jpg";